import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  activeTabSet,
  carStatusSet,
  getActiveTab,
} from '../../store/car-slice';
import { exitFullscreen } from '../../utils/fullscreen';

import FabControlled from '../../components/fab/fab-controlled';
import { zoomEnabledSet } from '../../store/car-slice';
import { urlParam } from '../../utils/url-param';
import theme from '../../config/theme';

const CloseButtonStyle = styled(Box)<any>(
  ({ orientation, tabvalue: tabValue, device }) => ({
    zIndex: 9,
    position: 'fixed',
    right: 20,
    top: 10,
    [theme.breakpoints.down('lg')]: {
      position: orientation === 'portrait' ? 'absolute' : 'fixed',
      top:
        orientation === 'portrait' && tabValue === 'exterior'
          ? '0'
          : orientation === 'landscape' && tabValue === 'exterior'
            ? '1.7rem'
            : orientation === 'landscape' &&
                tabValue.includes('interior') &&
                device === 'gadget'
              ? '1.3rem'
              : orientation === 'portrait' &&
                  tabValue.includes('interior') &&
                  device === 'gadget'
                ? '-2.7rem'
                : orientation === 'landscape' &&
                    tabValue.includes('interior') &&
                    device === 'camera'
                  ? '1.7rem'
                  : orientation === 'portrait' &&
                      tabValue.includes('interior') &&
                      device === 'camera'
                    ? '13em'
                    : '0',
      right: '1rem',
    },
    '@media(max-width: 500px)': {
      right: orientation === 'portrait' ? '0.35rem' : '1rem',
      top:
        orientation === 'portrait' && tabValue === 'exterior'
          ? '0'
          : orientation === 'landscape' && tabValue === 'exterior'
            ? '1.1rem'
            : orientation === 'portrait' &&
                tabValue.includes('interior') &&
                device === 'gadget'
              ? '-2.75rem'
              : orientation === 'landscape' &&
                  tabValue.includes('interior') &&
                  device === 'gadget'
                ? '1.7rem'
                : '',
    },
  }),
);

export default function CloseButton() {
  const dispatch = useDispatch();

  const activeTab = useSelector(getActiveTab);

  const device = urlParam('device');

  const isPortrait = useMediaQuery('(orientation: portrait)');

  const handleClose = () => {
    if (activeTab === 'interior') {
      dispatch(activeTabSet('exterior'));
      return;
    }
    dispatch(carStatusSet('VDP'));
    dispatch(activeTabSet('exterior'));
    exitFullscreen();
    dispatch(zoomEnabledSet(false));
  };

  return (
    <CloseButtonStyle
      device={device}
      orientation={isPortrait ? 'portrait' : 'landscape'}
      tabvalue={activeTab}
    >
      <FabControlled Icon={CloseRoundedIcon} onClick={handleClose} />
    </CloseButtonStyle>
  );
}
